
import { Card, Typography } from 'antd'
import Meta from 'antd/es/card/Meta'
import { NFTCover } from './NFTCover'

const { Title } = Typography

interface INFTCardProps {
  title: string
  cover?: string
}

export const NFTCard = ({ title, cover }: INFTCardProps): JSX.Element => {
  return (
  <Card
    hoverable
    style={{ width: '95%', marginBottom: 20, background: 'transparent', border: 'none' }}
    cover={<NFTCover cover={cover} style={{ minHeight: '190px', objectFit: 'fill' }}/>}
    >
    <Meta title={<Title style={{ fontFamily: 'PP Neue Machina', fontWeight: 600, marginBottom: 0, color: '#B6B9BF', fontSize: '24px', textAlign: 'center' }} level={5}>{title}</Title>} />
  </Card>
  )
}
